var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71631 6.00057C8.68281 6.00057 9.46631 6.78407 9.46631 7.75057V48.0006H49.7163C50.6828 48.0006 51.4663 48.7841 51.4663 49.7506C51.4663 50.7171 50.6828 51.5006 49.7163 51.5006H7.71631C6.74981 51.5006 5.96631 50.7171 5.96631 49.7506V7.75057C5.96631 6.78407 6.74981 6.00057 7.71631 6.00057Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4685 6.1704C51.3411 6.58593 51.7117 7.63018 51.2961 8.50279L39.6295 33.0028C39.392 33.5014 38.9332 33.8587 38.3916 33.9666C37.85 34.0746 37.2892 33.9206 36.8788 33.5512L26.9203 24.5885L18.6147 41.1997C18.1825 42.0642 17.1313 42.4146 16.2668 41.9823C15.4024 41.5501 15.052 40.4989 15.4842 39.6345L24.8175 20.9678C25.0619 20.4791 25.5204 20.1326 26.0572 20.031C26.5939 19.9293 27.1474 20.0842 27.5535 20.4496L37.4775 29.3812L48.1361 6.99802C48.5517 6.12541 49.5959 5.75487 50.4685 6.1704Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.be6ff383.svg";
export { ForwardRef as ReactComponent };